<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Cohort Profile"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('cohort_profile')
    "
  ></tool-header>

  <div class="main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Cohort Profile Tool.
      The Cohort Profile Tool displays academic attributes for different cohort
      by student type.
    </div>

    <div class="buttons-nav">
      <div class="example-button-row">
        <nav-page-link
          text="Profile Filters Guide"
          targetId="formguide"
          tooltipMessage="Navigate down"
        ></nav-page-link>
        <span> &nbsp; | &nbsp; </span>
        <nav-page-link
          text="Results after Submission"
          targetId="resultsguide"
          tooltipMessage="Navigate down"
        ></nav-page-link>
        <span> &nbsp; | &nbsp; </span>
        <nav-page-link
          text="Additional Filters for Graph"
          targetId="addfilters"
          tooltipMessage="Navigate down"
        ></nav-page-link>
        <span> &nbsp; | &nbsp; </span>
        <nav-page-link
          text="Cohort Table Results"
          targetId="tableresults"
          tooltipMessage="Navigate down"
        ></nav-page-link>
        <span> &nbsp; | &nbsp; </span>
        <nav-page-link
          text="Filter for Specific Students"
          targetId="filterstudents"
          tooltipMessage="Navigate down"
        ></nav-page-link>
      </div>
    </div>

    <!-------------------- COHORT PROFILE HELP GUIDE -------------------->
    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Success Metrics Section
          <i class="fa-solid fa-arrow-right"></i> Cohort Profile
        </h1>

        <!---------- Cohort Profile Tool At First Glance ---------->
        <h3 class="h3-second-header">Cohort Profile Tool At First Glance</h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 14. You will see default values in the form
            field that generates initial results.
          </li>
        </ol>

        <div>
          <br />
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageCohortFig14']"
            alt=""
          />
          <p class="picture-caption">Figure 14: Cohort Profile Tool Page</p>
        </div>

        <br />
        <mat-divider></mat-divider>
        <br />

        <!--------------- Cohort Profile Form Guide --------------->
        <div id="formguide">
          <h3 class="h3-second-header">
            Cohort Profile Form Guide (Figure 14a)
          </h3>

          <ol class="ordered-list">
            <li>
              Select the Year(s) (All Years, 2017, 2018, 2019, 2020, 2021, 2022)
            </li>
            <li>
              Select the Admit Type(s) (FTIC, FCSAA, FCSAS, OtherAA, OtherAS)
            </li>
            <li>Select the Tier(s) (All Years, 1, 2, 3, 4, 5, No Tier)</li>
            <li>Select the Financial Aid Status (All, Yes, No)</li>
            <li>Select the range for High School GPA (0 - 5)</li>
            <li>Select the range for UWF GPA (0 - 4)</li>
            <li>
              * Lastly, click on the ‘Submit’ button to generate results for
              Cohort Profile.
            </li>
          </ol>

          <div>
            <br />
            <img
              class="set-img-width-sm"
              [(src)]="env['logo_paths']['helpPageCohortFig14b']"
              alt=""
            />
            <p class="picture-caption">
              Figure 14a: Profile Filters with Default Values
            </p>
          </div>
        </div>

        <br />
        <mat-divider></mat-divider>
        <br />

        <!--------------- Results After Form Submission Explanation --------------->
        <h3 class="h3-second-header" id="resultsguide">
          Results after Form Submission
        </h3>

        <ul class="unordered-list">
          <li>
            After submitting the form, you will see two graphs just like the
            screenshot below (Figure 15 and 15b) being displayed with a table
            (Figure 16) of all the students in the cohort years you selected.
          </li>
          <li>
            For the first graph (Figure 15), you can click on the colored boxes
            just right above the graph to remove or add back a specific bar on
            the graph with the same color.
          </li>

          <div>
            <br />
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageCohortFig15']"
              alt=""
            />
            <p class="picture-caption">
              Figure 15: Cohort Profile Results Graph 1
            </p>
          </div>

          <br />
          <mat-divider></mat-divider>
          <br />

          <h3 class="h3-second-header" id="addfilters">Additional Filters</h3>

          <li>
            As you scroll down the page to view the results, you will see three
            additional filters (Figure15a) that is for the second graph
            (Figure15b).
          </li>

          <li>
            The additional filters right above the second graph are meant for
            you to filter the results with specific student groups and
            attributes that are targeting to identify specific students.
          </li>

          <div>
            <br />
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageCohortFig15a']"
              alt=""
            />
            <p class="picture-caption">Figure 15a: Additional Filters</p>
          </div>

          <div>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageCohortFig15b']"
              alt=""
            />
            <p class="picture-caption">
              Figure 15b: Cohort Profile Results Graph 2
            </p>
          </div>

          <br />
          <mat-divider></mat-divider>
          <br />

          <h3 class="h3-second-header" id="tableresults">
            Cohort Table Result with Filters
          </h3>

          <li>
            As for the table (Figure 16a), you will have filters (Figure 16) to
            filter cohort, year, multiple tiers, college, and many other filter
            options.
          </li>
          <li>
            There are also two buttons below the filters. One of the buttons to
            reset the form filter (green color button) and the other to export
            the results of the table with or without filtering (blue color
            button).
          </li>

          <div>
            <br />
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageCohortFig16a']"
              alt=""
            />
            <p class="picture-caption">
              Figure 16: Filters Above Result Table in Cohort Profile Page
            </p>
          </div>

          <div>
            <br />
            <img
              class="list-photo"
              [(src)]="env['logo_paths']['helpPageCohortFig16']"
              alt=""
            />
            <p class="picture-caption">
              Figure 16a: Cohort Profile Table Results
            </p>
          </div>

          <br />
          <mat-divider></mat-divider>
          <br />

          <h3 class="h3-second-header" id="filterstudents">
            Filtering for Specific Students in Table
          </h3>

          <li>
            If you would like to filter for example an at-risk student that is
            still active, you can do so by selecting ‘yes’ for the at-risk
            filter and ‘active’ for the active status filter. Just like the
            image below (Figure 16b)
          </li>

          <div>
            <br />
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageCohortFig16b']"
              alt=""
            />
            <p class="picture-caption">
              Figure 16b: Filtering for At-Risk Students
            </p>
          </div>

          <li>
            In the table, you can also scroll horizontally to view other columns
            of information. If you click on a specific row (Figure 16c), you
            will be directed to the
            <a
              (click)="navigateToOtherHelpPage()"
              matTooltip="Navigate to page"
              class="instruction-step-anchor"
              [ngStyle]="{
                color: isHovered[5]
                  ? env['colors']['tool_btn_active']
                  : 'black',
              }"
              (mouseover)="setHover(5, true)"
              (mouseout)="setHover(5, false)"
              >Student Profile page</a
            >. and in there you can view that specific student that you clicked
            on previously in the Cohort Profile page.
          </li>

          <div>
            <br />
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageCohortFig16c']"
              alt=""
            />
            <p class="picture-caption">
              Figure 16c: To view student in Student Profile
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Cohort Profile',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
